
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256.504 512.495c-141.583 0-255.999-114.417-255.999-256 0-141.584 114.416-256 255.999-256 141.584 0 256.001 114.416 256.001 256 0 141.583-114.417 256-256.001 256zm0-484.133c-126.333 0-228.133 101.8-228.133 228.133 0 54.281 19.131 105.206 50.736 144.299 2.378-2.598 10.527-9.855 14.465-13.137 45.248-37.109 96.278-62.54 105.507-67.051a3.027 3.027 0 001.678-2.728l-3.413-68.305c-8.823-5.883-14.705-15.953-14.705-27.381V147.57c0-36.319 30.284-65.735 66.596-65.735h15.61c36.312 0 66.596 29.417 66.596 65.735v74.622c0 11.428-5.882 21.498-14.705 27.381l-3.413 68.305c0 1.153.63 2.202 1.679 2.728 9.229 4.511 60.506 29.912 105.641 67.022 4.192 3.396 11.667 10.909 13.366 12.629 31.152-39.075 50.63-90.252 50.63-143.763-.001-126.332-101.801-228.132-228.135-228.132z"}})])
          )
        }
      }
    